package top.wcpe.allincore.ui.runtime.style

import kotlin.jvm.JvmName

/**
 * 单条阴影规格：多重阴影（`boxShadows`）列表中的一项。
 *
 * 语义对齐 CSS box-shadow：偏移 / 模糊 / 扩展 / 颜色 / 内阴影标志。
 *
 * @param offsetX X 偏移（像素）
 * @param offsetY Y 偏移（像素）
 * @param blur    模糊半径（像素）
 * @param spread  扩展半径（像素）
 * @param color   阴影颜色（ARGB）
 * @param inset   是否为内阴影
 */
data class ShadowSpec(
    @get:JvmName("offsetX") val offsetX: Float,
    @get:JvmName("offsetY") val offsetY: Float,
    @get:JvmName("blur") val blur: Float,
    @get:JvmName("spread") val spread: Float,
    @get:JvmName("color") val color: Int,
    @get:JvmName("inset") val inset: Boolean,
) {
    /**
     * 是否需要绘制：必须同时满足"有几何参数"和"颜色非透明"。
     */
    fun isVisible(): Boolean {
        val hasGeometry = blur > 0 || spread > 0 || offsetX != 0f || offsetY != 0f
        val hasColor = (color ushr 24) != 0
        return hasGeometry && hasColor
    }
}
